import * as React from "react";
import { getDisplayName } from "@grandvisionhq/utils";
function withAnchor(Component) {
  const displayName = getDisplayName(Component);
  const WithAnchor = (props) => {
    const { page, component } = props;
    const preview = page.isPreview();
    const { anchorId } = component.getParameters() ?? {};
    return anchorId && anchorId !== "" && !preview ? /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "anchor-wrapper",
        id: anchorId,
        style: { marginTop: "-120px", paddingTop: "120px" }
      },
      /* @__PURE__ */ React.createElement(Component, { ...props })
    ) : /* @__PURE__ */ React.createElement(Component, { ...props });
  };
  WithAnchor.displayName = `withAnchor(${displayName})`;
  return WithAnchor;
}
export {
  withAnchor
};
//# sourceMappingURL=with-anchor.js.map
